import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { DefaultCustomField, Message } from '../../../../constants/types';
import { convertHtmlToText } from '../../../../helpers/helpers';
import { SendTestMessageDialog } from './SendTestMessageDialog';

type SendTestMessageButtonProps = {
  messages: Message[];
  optOutText: string | undefined;
  metadata: DefaultCustomField[] | undefined;
  disabled?: boolean;
};

export function SendTestMessageButton({ messages, optOutText, metadata, disabled }: SendTestMessageButtonProps) {
  const [open, setOpen] = useState(false);
  const sendableMessages = messages.filter(message => (
    convertHtmlToText(message.text).trim() || message.links?.length
  ));

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }} onClick={event => event.stopPropagation()}>
      <Button
        aria-label="Send Test Message"
        variant="outlined"
        disabled={disabled || sendableMessages.length === 0}
        onClick={() => setOpen(true)}
        sx={{ whiteSpace: 'nowrap' }}
      >
        Send Test Message
      </Button>
      {open && (
        <SendTestMessageDialog
          open={open}
          onClose={() => setOpen(false)}
          messages={sendableMessages}
          optOutText={optOutText}
          metadata={metadata}
        />
      )}
    </Box>
  );
}
